'use client';

import React from 'react';

interface SelectOption {
  value: string | number;
  label: React.ReactNode;
  disabled?: boolean;
}

interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'onChange'> {
  options?: SelectOption[];
  onChange?: (value: string) => void;
  status?: 'error' | 'warning';
  placeholder?: string;
}

export default function Select({
  options = [],
  onChange,
  status,
  placeholder,
  className,
  value,
  ...rest
}: SelectProps) {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange?.(e.target.value);
  };

  return (
    <span className="ui-select-wrapper">
      <select
        value={value ?? ''}
        onChange={handleChange}
        className={['ui-select', status, className].filter(Boolean).join(' ')}
        {...rest}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value} disabled={opt.disabled}>
            {opt.label}
          </option>
        ))}
      </select>
    </span>
  );
}
